import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  StyleProp,
  ViewStyle,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';
import AntDesign from 'react-native-vector-icons/AntDesign';
import BrandLogo from '../components/BrandLogo';

export interface LoginOptionsPanelProps {
  t: (key: string) => string;
  privacyAgreed: boolean;
  onTogglePrivacy: () => void;
  onPasswordLogin: () => void;
  onGoogleLogin: () => void;
  onRegister: () => void;
  onNavigateToTerms: () => void;
  onNavigateToPrivacy: () => void;
  containerStyle?: StyleProp<ViewStyle>;
}

const LoginOptionsPanel: React.FC<LoginOptionsPanelProps> = ({
  t,
  privacyAgreed,
  onTogglePrivacy,
  onPasswordLogin,
  onGoogleLogin,
  onRegister,
  onNavigateToTerms,
  onNavigateToPrivacy,
  containerStyle,
}) => {
  return (
    <View style={[styles.wrapper, containerStyle]}> 
      <View style={styles.logoContainer}>
        <BrandLogo size={100} />
      </View>

      <View style={styles.buttonContainer}>
        <TouchableOpacity
          style={[styles.mainButton, styles.passwordButton]}
          onPress={onPasswordLogin}
        >
          <Icon name="lock" size={20} color="#fff" style={styles.buttonIcon} />
          <Text style={[styles.mainButtonText, styles.passwordButtonText]}>
            {t('auth.passwordLogin')}
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[styles.mainButton, styles.googleButton]}
          onPress={onGoogleLogin}
        >
          <AntDesign name="google" size={20} color="#4285f4" style={styles.buttonIcon} />
          <Text style={styles.mainButtonText}>{t('auth.googleLogin')}</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.mainButton, styles.registerButton]}
          onPress={onRegister}
        >
          <Icon name="person-add" size={20} color="#333" style={styles.buttonIcon} />
          <Text style={styles.mainButtonText}>{t('auth.register')}</Text>
        </TouchableOpacity>
      </View>

      <View style={styles.privacyContainer}>
        <TouchableOpacity style={styles.privacyCheckContainer} onPress={onTogglePrivacy}>
          <Icon
            name={privacyAgreed ? 'check-box' : 'check-box-outline-blank'}
            size={20}
            color={privacyAgreed ? '#3B82F6' : '#9CA3AF'}
          />
          <View style={styles.privacyTextContainer}>
            <Text style={styles.privacyText}>{t('auth.iHaveReadAndAgree')} </Text>
            <TouchableOpacity onPress={onNavigateToTerms}>
              <Text style={styles.privacyLink}>{t('auth.termsOfService')}</Text>
            </TouchableOpacity>
            <Text style={styles.privacyText}> {t('auth.and')} </Text>
            <TouchableOpacity onPress={onNavigateToPrivacy}>
              <Text style={styles.privacyLink}>{t('auth.privacyPolicy')}</Text>
            </TouchableOpacity>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    flexGrow: 1,
    maxWidth: 540,
    alignSelf: 'center',
    // Create a vertical flow where the bottom section can stick downwards
    justifyContent: 'flex-start',
  },
  logoContainer: {
    alignItems: 'center',
    marginTop: 80,
    marginBottom: 40,
  },
  buttonContainer: {
    paddingHorizontal: 20,
    marginBottom: 16,
    marginTop: 0,
  },
  mainButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: 52,
    borderRadius: 12,
    marginBottom: 16,
    paddingHorizontal: 20,
  },
  passwordButton: {
    backgroundColor: '#007AFF',
  },
  googleButton: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#E5E5E5',
  },
  guestButton: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#E5E5E5',
  },
  registerButton: {
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#E5E5E5',
  },
  buttonIcon: {
    marginRight: 8,
  },
  mainButtonText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
  },
  passwordButtonText: {
    color: '#fff',
  },
  privacyContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: 16,
    marginTop: 'auto',
  },
  privacyCheckContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 16,
  },
  privacyTextContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 8,
    flex: 1,
  },
  privacyText: {
    fontSize: 14,
    color: '#666',
    textAlign: 'center',
  },
  privacyLink: {
    color: '#3B82F6',
    fontWeight: '500',
    fontSize: 14,
  },
});

export default LoginOptionsPanel;
